import { useQuery } from "@tanstack/react-query";

import type { PortalUser } from "@/app/models";
import { consultationsQueriesStore } from "@/features/consultations/api";
import { useScheduleContext } from "@/features/consultations/contexts";

interface useTimeSlotsParams {
  disabled?: boolean;
  userId?: PortalUser["patientId"];
}

export const useTimeSlotsQuery = ({ disabled, userId }: useTimeSlotsParams) => {
  const {
    language,
    scheduleDate: { appointmentDate: date },
    provider,
    appointmentType: type,
    subscriptionId,
  } = useScheduleContext();

  return useQuery({
    ...consultationsQueriesStore.consultations.providers._ctx.availability._ctx.timeSlots(
      {
        date,
        providerId: provider?.id,
        language,
        userId,
        appointmentType: type,
        subscriptionId,
      },
    ),
    enabled: !disabled,
  });
};
